/* RESPONSIBLE TEAM: team-frontend-tech */
import { PropsWithChildren, useState } from 'react';
import { RootElementContext } from '@/providers/root-element/root-element-context';
import isEmbedded from '@/utils/is-embedded';

export const RootElementProvider = ({ children }: PropsWithChildren) => {
  const [rootElement, setRootElement] = useState<Element | null>(() => {
    return isEmbedded() ? null : document.documentElement;
  });

  const rootElementRef = (element: HTMLElement | null) => {
    if (!element) {
      setRootElement(null);
      return;
    }

    // In embedded mode, look for specific container types
    const rootNode = element.getRootNode();

    if (rootNode instanceof ShadowRoot) {
      // Look for the island container
      const islandContainer = rootNode.getElementById('react-teammate-app-island-container');
      if (islandContainer) {
        setRootElement(islandContainer);
        return;
      }

      // Then try to find component containers (IDs starting with 'react-component-container-')
      const componentContainer = rootNode.querySelector('[id^="react-component-container-"]');
      if (componentContainer) {
        setRootElement(componentContainer);
        return;
      }
    }

    setRootElement(null);
  };

  return (
    <>
      <RootElementContext value={rootElement}>{children}</RootElementContext>
      {isEmbedded() && <div ref={rootElementRef} className="hidden" data-root-element-detector />}
    </>
  );
};
